import {
  EXTERNAL_API_LOAD_EXTERNAL_APIS_BEGIN,
  EXTERNAL_API_LOAD_EXTERNAL_APIS_SUCCESS,
  EXTERNAL_API_LOAD_EXTERNAL_APIS_FAILURE,
  EXTERNAL_API_LOAD_EXTERNAL_APIS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadExternalApis(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EXTERNAL_API_LOAD_EXTERNAL_APIS_BEGIN,
    });

    let isPaginated = false;
    const { projectId, version, searchTerm, externalApiType, page, limit } = args;
    let header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/?${
        searchTerm ? `searchTerm=${searchTerm}` : ''
      }`;
      if (externalApiType) {
        url += `&externalApiType=${externalApiType}`;
      }
      if (page || page === 0) {
        url += `&limit=${limit}&page=${page}`;
        isPaginated = true;
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: EXTERNAL_API_LOAD_EXTERNAL_APIS_SUCCESS,
            data: res.data,
            isPaginated: isPaginated,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_LOAD_EXTERNAL_APIS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalApisError() {
  return {
    type: EXTERNAL_API_LOAD_EXTERNAL_APIS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_LOAD_EXTERNAL_APIS_BEGIN:
      return {
        ...state,
        loadExternalApisPending: true,
        loadExternalApisError: null,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_APIS_SUCCESS:
      return {
        ...state,
        loadExternalApisPending: false,
        loadExternalApisError: null,
        externalApis: action.isPaginated
          ? action.data && action.data.content
            ? action.data.content
            : []
          : action.data
          ? action.data
          : [],
        totalExternalApisPages: action.data.totalPages,
        externalApiData: null,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_APIS_FAILURE:
      return {
        ...state,
        loadExternalApisPending: false,
        loadExternalApisError: action.data.error,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_APIS_DISMISS_ERROR:
      return {
        ...state,
        loadExternalApisError: null,
      };

    default:
      return state;
  }
}
